import React, { useState, useEffect } from 'react'
import { useDispatch } from 'react-redux';
import { Grid } from '@mui/material';

import CompositionDashboard from '../CompositionDashboard';

import { openDrawer } from './../../../store/slice/MenuSlice';

export default function CompositionPage() {
    const dispatch = useDispatch();
    useEffect(() => {
        dispatch(openDrawer(false));
    },[]);

    return (
        < CompositionDashboard />
    )

}